import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css'
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { SingleDatePicker } from 'react-dates';
import styled from 'react-emotion';

import Style from '../../../../styles/common';

const Container = styled('div')`  
  margin-top: -3px; // rc-time-picker popup alignment hack
  
  .DateInput_input {
    border-bottom: 0;
    font-size: ${Style.FONT_SIZE.M};
    padding-bottom: ${Style.SPACING.S};
    padding-top: ${Style.SPACING.S};

    ::placeholder {
      color: ${Style.color.PLACEHOLDER};
    }
  }
  
  .SingleDatePicker_picker {
    border-radius: ${Style.BORDER_RADIUS};
    margin-top: ${Style.MEASUREMENT.INPUT.MODAL_OFFSET};
  }
  
  .DayPicker__withBorder {
    border: 1px solid ${Style.color.INPUT.BORDER};
    border-radius: ${Style.BORDER_RADIUS};
    box-shadow: ${Style.INPUT_MODAL_BOX_SHADOW};
  }
  
  .DayPicker_transitionContainer {
    margin-left: -3px;
  }
  
  .SingleDatePickerInput {
    border-color: ${Style.color.INPUT.BORDER};
    border-bottom-left-radius: ${Style.BORDER_RADIUS};
    border-top-left-radius: ${Style.BORDER_RADIUS};
    border-right: 0;
    padding-right: 4px;
  }

  
  .DateInput_fang {
    display: none;
  }
  
  .CalendarMonth_caption {
    padding-bottom: 55px; 
  }
  
  .CalendarDay {
    border: 0;
    border-radius: ${Style.BORDER_RADIUS};

    &:hover {
      background-color: ${Style.color.INPUT.HOVER};
    }
  }
  
  .CalendarDay__selected {
    font-weight: ${Style.FONT_WEIGHT.BOLD};
    
    &, 
    &:hover, 
    &:active {
      background: ${Style.color.INPUT.ACTIVE};
      border-color: ${Style.color.INPUT.ACTIVE};
    }
  }
`;

class DateInput extends React.Component {
  static propTypes = {
    defaultDate: PropTypes.object.isRequired,
    input: PropTypes.object.isRequired,
  };

  state = {
    hasFocus: false,
  };

  render() {
    const { input } = this.props;

    return (
      <Container>
        <SingleDatePicker
          date={input.value}
          daySize={44}
          onDateChange={this.onDateChange}
          focused={this.state.hasFocus}
          hideKeyboardShortcutsPanel={true}
          numberOfMonths={1}
          onFocusChange={this.onFocusChange}
          showDefaultInputIcon={true}
        />
      </Container>
    );
  }

  onDateChange = value => {
    const stateValue = this.props.input.value ?
      this.props.input.value.clone() : this.props.defaultDate;
    this.props.input.onChange(
      stateValue.set({
        year: value.year(),
        month: value.month(),
        date: value.date(),
      })
    );
  };

  onFocusChange = ({ focused }) => {
    this.setState({ hasFocus: focused });
    focused ? this.props.input.onFocus() : this.props.input.onBlur();
  };
}

export default DateInput;



// WEBPACK FOOTER //
// ./src/components/Form/DateTimeInput/DateInput/DateInput.js